'use client';

import { COLOR_MODE_COOKIE_NAME, ColorMode } from '@/helpers';
import { text } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { setCookie } from '@onbeam/utils';
import { useState } from 'react';
import { ColorModeButtonProps } from './ColorModeButton.types';
import { DarkModeIcon, LightModeIcon } from '@onbeam/icons/business';

export const ColorModeButton = ({ initial }: ColorModeButtonProps) => {
  const [colorMode, setColorMode] = useState<ColorMode>(initial);

  const onColorModeChange = () => {
    setColorMode((currentMode) => {
      const newMode =
        currentMode === ColorMode.LIGHT ? ColorMode.DARK : ColorMode.LIGHT;
      setCookie(COLOR_MODE_COOKIE_NAME, newMode);
      document.body.classList.remove(currentMode);
      document.body.classList.add(newMode);
      return newMode;
    });
  };

  return (
    <Button
      type="button"
      variant="secondary"
      onClick={onColorModeChange}
      className={text({ textTransform: 'capitalize' })}
      iconLeft={
        colorMode === ColorMode.DARK ? <DarkModeIcon /> : <LightModeIcon />
      }
    >
      {colorMode.toLowerCase()}
    </Button>
  );
};
